module.exports = __webpack_public_path__ + "8cabf1be11fdde95fb75411d0a9326aa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-11.png
// module id = 2994
// module chunks = 0